// temi/caratteri.ts — i caratteri dei temi non gratuiti si scaricano solo quando qualcuno sceglie quel tema
// (chi usa i temi gratuiti non paga i loro chilobyte). I caratteri dei temi gratuiti sono in main.tsx.
// Finché il carattere arriva si vede quello di ripiego (font-display: swap delle CSS di Fontsource).
import type { IdTema } from "./temi.ts";

const CARICA: Partial<Record<IdTema, () => Promise<unknown>>> = {
  fumetto: () => Promise.all([import("@fontsource/bangers/400.css"), import("@fontsource/comic-neue/400.css"), import("@fontsource/comic-neue/700.css")]),
  retro: () => import("@fontsource/shrikhand/400.css"),
  pastelli: () => import("@fontsource/patrick-hand/400.css"),
  tropicale: () => Promise.all([import("@fontsource/fredoka/500.css"), import("@fontsource/fredoka/700.css")]),
};

const caricati = new Set<IdTema>();

export function caricaCaratteri(id: IdTema): void {
  const f = CARICA[id];
  if (!f || caricati.has(id)) return;
  caricati.add(id);
  // Senza rete il tema resta con il carattere di ripiego: nessun errore da mostrare; si riprova la prossima volta.
  f().catch(() => caricati.delete(id));
}
